import type { $ } from "../../../dom";
import { type InputOptions, type InputWithItemValue } from "../../core";
import { ButtonInput } from "../base";

export type SimpleButtonInputOptions = Omit<
  InputOptions<string | null>,
  "resetValue"
> & {};

export class SimpleButtonInput
  extends ButtonInput<string | null>
  implements InputWithItemValue<string | null>
{
  constructor($root: $, options: SimpleButtonInputOptions = {}) {
    const { ...superOptions } = options;

    super($root, {
      resetValue: null,
      ...superOptions,
    });
  }

  private getItemText(): string {
    return this.$root.text;
  }

  getItemValue(): string {
    return this.$root.rk("value") || this.getItemText();
  }

  get value(): string | null {
    return this.isActive ? this.getItemValue() : null;
  }

  set value(value: string | null) {
    this.isActive = value === this.getItemValue();
  }

  get data(): string | null {
    return this.isActive ? this.getItemText() : null;
  }
}
